import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getNews = () =>
  axiosInstance.get(`${LANDING_API_URL}/news`, {
    headers: authHeaders(),
  });

export const createNewsRequest = (newsData) =>
  axiosInstance.post(`${LANDING_API_URL}/news`, newsData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const updateNewsRequest = (newsId, updatedData) =>
  axiosInstance.post(`${LANDING_API_URL}/news/${newsId}`, updatedData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const removeNews = (newsId) =>
  axiosInstance.delete(`${LANDING_API_URL}/news/${newsId}`, {
    headers: authHeaders(),
  });
